export const LOADINGIMAGE = "/assets/images/spinner/iphone-spinner-1.gif";